var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphoneBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_40_4",
    "data-name": "Component 40 \\u2013 4",
    xmlns: "http://www.w3.org/2000/svg",
    width: 161.546,
    height: 54,
    viewBox: "0 0 161.546 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1826",
    "data-name": "Group 1826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1821",
    "data-name": "Group 1821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1820",
    "data-name": "Group 1820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4033",
    "data-name": "Path 4033",
    d: "M148.682,0H12.872c-.5,0-.984,0-1.478,0-.413,0-.823.011-1.241.018A17.76,17.76,0,0,0,7.448.258,9.072,9.072,0,0,0,4.882,1.1,8.7,8.7,0,0,0,2.7,2.7,8.484,8.484,0,0,0,1.106,4.884,8.944,8.944,0,0,0,.262,7.453a17.655,17.655,0,0,0-.242,2.7c-.012.414-.013.83-.02,1.243V42.6c.007.418.008.825.02,1.243a17.625,17.625,0,0,0,.242,2.7,8.92,8.92,0,0,0,.844,2.572A8.414,8.414,0,0,0,2.7,51.3a8.5,8.5,0,0,0,2.184,1.592,9.039,9.039,0,0,0,2.566.851,17.937,17.937,0,0,0,2.705.239c.417.009.828.015,1.241.015.494,0,.983,0,1.478,0h135.81c.485,0,.977,0,1.463,0,.41,0,.833-.005,1.245-.015a17.714,17.714,0,0,0,2.7-.239,9.155,9.155,0,0,0,2.576-.851,8.521,8.521,0,0,0,2.183-1.592,8.654,8.654,0,0,0,1.6-2.179,8.945,8.945,0,0,0,.836-2.572,18.159,18.159,0,0,0,.25-2.7c.005-.419.005-.825.005-1.243.011-.491.011-.979.011-1.477V12.874c0-.494,0-.984-.011-1.474,0-.413,0-.829-.005-1.243a18.193,18.193,0,0,0-.25-2.7,8.969,8.969,0,0,0-.836-2.569,8.74,8.74,0,0,0-3.779-3.78A9.189,9.189,0,0,0,154.09.258a17.541,17.541,0,0,0-2.7-.238c-.412-.007-.834-.015-1.245-.018-.486,0-.979,0-1.463,0Z",
    fill: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4034",
    "data-name": "Path 4034",
    d: "M11.1,52.512c-.412,0-.813-.005-1.22-.015a17.035,17.035,0,0,1-2.524-.22,7.918,7.918,0,0,1-2.236-.74,7.254,7.254,0,0,1-1.886-1.372A7.194,7.194,0,0,1,1.85,48.28a7.765,7.765,0,0,1-.733-2.237,16.723,16.723,0,0,1-.224-2.531c-.009-.285-.02-1.233-.02-1.233V11.093s.012-.933.02-1.207a16.672,16.672,0,0,1,.223-2.527A7.729,7.729,0,0,1,1.85,5.115a7.206,7.206,0,0,1,1.37-1.887A7.516,7.516,0,0,1,5.113,1.847a7.855,7.855,0,0,1,2.232-.734A17.078,17.078,0,0,1,9.877.891L11.1.875H149.833l1.233.018a16.685,16.685,0,0,1,2.508.219,8.035,8.035,0,0,1,2.256.74,7.55,7.55,0,0,1,3.26,3.267,7.745,7.745,0,0,1,.722,2.226,17.306,17.306,0,0,1,.235,2.547c0,.382,0,.794,0,1.2.011.506.011.988.011,1.474V40.821c0,.49,0,.969-.011,1.451,0,.439,0,.841-.005,1.255a16.951,16.951,0,0,1-.231,2.5,7.723,7.723,0,0,1-.729,2.254,7.391,7.391,0,0,1-1.37,1.871,7.274,7.274,0,0,1-1.89,1.38,7.873,7.873,0,0,1-2.252.743,16.82,16.82,0,0,1-2.523.22c-.4.009-.809.015-1.211.015l-1.463,0Z",
    transform: "translate(0.306 0.306)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1825",
    "data-name": "Group 1825",
    transform: "translate(13.462 11.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1823",
    "data-name": "Group 1823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1822",
    "data-name": "Group 1822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4035",
    "data-name": "Path 4035",
    d: "M29.948,22.516a6.68,6.68,0,0,1,3.181-5.605A6.835,6.835,0,0,0,27.741,14c-2.267-.238-4.464,1.357-5.62,1.357-1.177,0-2.955-1.334-4.871-1.293a7.174,7.174,0,0,0-6.039,3.681c-2.611,4.521-.663,11.164,1.837,14.819,1.251,1.789,2.713,3.787,4.628,3.717,1.872-.078,2.572-1.195,4.832-1.195,2.24,0,2.9,1.195,4.848,1.15,2.01-.034,3.275-1.8,4.483-3.6a14.79,14.79,0,0,0,2.049-4.174A6.455,6.455,0,0,1,29.948,22.516Z",
    transform: "translate(-9.972 -6.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M23.179,13.433A6.58,6.58,0,0,0,24.684,8.72a6.7,6.7,0,0,0-4.331,2.241A6.261,6.261,0,0,0,18.809,15.5,5.535,5.535,0,0,0,23.179,13.433Z",
    transform: "translate(-6.891 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1824",
    "data-name": "Group 1824",
    transform: "translate(33.015 12.354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4037",
    "data-name": "Path 4037",
    d: "M45.058,30.312h-6.39l-1.535,4.531H34.427L40.48,18.078h2.812l6.052,16.764H46.592ZM39.33,28.221H44.4l-2.5-7.353h-.069Z",
    transform: "translate(-34.427 -17.799)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4038",
    "data-name": "Path 4038",
    d: "M58.145,27.588c0,3.8-2.033,6.238-5.1,6.238A4.142,4.142,0,0,1,49.2,31.688h-.058v6.053h-2.51V21.475H49.06v2.033h.046A4.339,4.339,0,0,1,53,21.348C56.1,21.348,58.145,23.8,58.145,27.588Zm-2.578,0c0-2.475-1.28-4.1-3.231-4.1-1.917,0-3.206,1.66-3.206,4.1,0,2.462,1.289,4.112,3.206,4.112C54.287,31.7,55.567,30.084,55.567,27.588Z",
    transform: "translate(-30.156 -16.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M68.11,27.588c0,3.8-2.033,6.238-5.1,6.238a4.142,4.142,0,0,1-3.845-2.138h-.058v6.053H56.6V21.475h2.429v2.033h.046a4.337,4.337,0,0,1,3.892-2.16C66.065,21.348,68.11,23.8,68.11,27.588Zm-2.58,0c0-2.475-1.278-4.1-3.229-4.1-1.917,0-3.206,1.66-3.206,4.1,0,2.462,1.289,4.112,3.206,4.112C64.252,31.7,65.53,30.084,65.53,27.588Z",
    transform: "translate(-26.668 -16.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4040",
    "data-name": "Path 4040",
    d: "M72.376,30.244c.186,1.663,1.8,2.754,4.008,2.754,2.115,0,3.637-1.091,3.637-2.591,0-1.3-.918-2.08-3.09-2.614l-2.173-.524c-3.078-.744-4.508-2.183-4.508-4.52,0-2.892,2.52-4.879,6.1-4.879,3.542,0,5.971,1.987,6.052,4.879H79.87c-.151-1.673-1.534-2.682-3.556-2.682s-3.4,1.022-3.4,2.508c0,1.185.883,1.883,3.044,2.416l1.847.454c3.44.814,4.868,2.2,4.868,4.648,0,3.136-2.5,5.1-6.471,5.1-3.718,0-6.229-1.918-6.391-4.95Z",
    transform: "translate(-22.044 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4041",
    "data-name": "Path 4041",
    d: "M84.46,19.3v2.892h2.325v1.987H84.46v6.738c0,1.048.466,1.535,1.488,1.535a7.7,7.7,0,0,0,.825-.058v1.975a6.861,6.861,0,0,1-1.393.116c-2.475,0-3.44-.93-3.44-3.3V24.179H80.163V22.192H81.94V19.3Z",
    transform: "translate(-18.42 -17.371)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4042",
    "data-name": "Path 4042",
    d: "M86.065,27.594c0-3.846,2.265-6.263,5.8-6.263s5.8,2.416,5.8,6.263-2.242,6.261-5.8,6.261S86.065,31.449,86.065,27.594Zm9.038,0c0-2.638-1.208-4.2-3.241-4.2s-3.24,1.569-3.24,4.2c0,2.649,1.207,4.193,3.24,4.193S95.1,30.242,95.1,27.594Z",
    transform: "translate(-16.354 -16.66)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4043",
    "data-name": "Path 4043",
    d: "M96.186,21.475H98.58v2.08h.057a2.917,2.917,0,0,1,2.94-2.207,3.894,3.894,0,0,1,.86.093v2.346a3.537,3.537,0,0,0-1.127-.151,2.529,2.529,0,0,0-2.615,2.812V33.7H96.186Z",
    transform: "translate(-12.812 -16.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4044",
    "data-name": "Path 4044",
    d: "M112.242,30.114c-.338,2.218-2.5,3.741-5.262,3.741-3.556,0-5.763-2.381-5.763-6.2s2.219-6.321,5.658-6.321c3.382,0,5.508,2.323,5.508,6.029v.86H103.75v.151a3.183,3.183,0,0,0,3.289,3.461,2.766,2.766,0,0,0,2.823-1.719Zm-8.481-3.648h6.11a2.939,2.939,0,0,0-3-3.1A3.1,3.1,0,0,0,103.762,26.466Z",
    transform: "translate(-11.051 -16.66)",
    fill: "#fff"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1828",
    "data-name": "Group 1828",
    transform: "translate(48.156 11.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1827",
    "data-name": "Group 1827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4045",
    "data-name": "Path 4045",
    d: "M40.7,16.786H35.671V8.731h1.251v6.905H40.7Z",
    transform: "translate(-35.671 -8.172)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4046",
    "data-name": "Path 4046",
    d: "M40.329,14.585c0-1.094.815-1.725,2.261-1.814l1.647-.094v-.525c0-.641-.425-1-1.245-1-.67,0-1.134.246-1.268.675H40.564c.123-1.044,1.1-1.713,2.484-1.713,1.524,0,2.383.759,2.383,2.043V16.3H44.276V15.45h-.094a2.046,2.046,0,0,1-1.827.954A1.837,1.837,0,0,1,40.329,14.585Zm3.908-.518v-.509l-1.485.094c-.837.057-1.216.342-1.216.878s.474.865,1.127.865A1.433,1.433,0,0,0,44.237,14.066Z",
    transform: "translate(-34.041 -7.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4047",
    "data-name": "Path 4047",
    d: "M45.276,13.846c0-1.921.988-3.137,2.524-3.137a2,2,0,0,1,1.863,1.066h.09V8.437h1.2v8.452H49.8v-.961h-.094A2.109,2.109,0,0,1,47.8,16.989C46.253,16.989,45.276,15.773,45.276,13.846Zm1.239,0c0,1.289.609,2.065,1.624,2.065s1.636-.787,1.636-2.06-.63-2.065-1.636-2.065S46.515,12.568,46.515,13.846Z",
    transform: "translate(-32.309 -8.275)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4048",
    "data-name": "Path 4048",
    d: "M56.158,14.663a2.467,2.467,0,0,1-2.634,1.759c-1.741,0-2.808-1.195-2.808-3.139s1.088-3.175,2.8-3.175c1.692,0,2.712,1.156,2.712,3.064v.418H51.938v.068A1.607,1.607,0,0,0,53.556,15.4,1.46,1.46,0,0,0,55,14.663ZM51.938,12.7h3.071a1.468,1.468,0,0,0-1.5-1.575A1.556,1.556,0,0,0,51.938,12.7Z",
    transform: "translate(-30.405 -7.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4049",
    "data-name": "Path 4049",
    d: "M55.994,10.225H57.15v.965h.089a1.821,1.821,0,0,1,1.814-1.083,1.976,1.976,0,0,1,2.1,2.261V16.3h-1.2V12.67c0-.977-.425-1.463-1.312-1.463a1.4,1.4,0,0,0-1.451,1.54V16.3h-1.2Z",
    transform: "translate(-28.558 -7.69)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4050",
    "data-name": "Path 4050",
    d: "M63.52,9.054a.777.777,0,1,1,.776.732A.739.739,0,0,1,63.52,9.054Zm.178,1.8h1.195v6.079H63.7Z",
    transform: "translate(-25.924 -8.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4051",
    "data-name": "Path 4051",
    d: "M65.971,10.225h1.156V11.2h.089a1.842,1.842,0,0,1,3.366,0h.1a1.974,1.974,0,0,1,1.848-1.093,1.806,1.806,0,0,1,1.941,2.009V16.3h-1.2V12.43c0-.821-.393-1.223-1.18-1.223a1.231,1.231,0,0,0-1.282,1.273V16.3H69.627V12.313a1.059,1.059,0,0,0-1.172-1.106,1.308,1.308,0,0,0-1.284,1.38V16.3h-1.2Z",
    transform: "translate(-25.066 -7.69)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphoneBanner);
export default __webpack_public_path__ + "static/media/iphone-banner.8cf594ef9e5104c60ffaed12067881e3.svg";
export { ForwardRef as ReactComponent };